import { getSearchParams } from '@/shared/utils/get-search-params';
import { RU_LOCALE } from '@/shared/constants/constants';

export const setLang = () => {
    const html = document.querySelector('html');
    const { lang = RU_LOCALE } = getSearchParams();
    html && (html.lang = lang);
};

setLang();
